import { Route, Routes, useNavigate} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {Button, Col,  Row, Dropdown, DropdownButton   } from "react-bootstrap";
import {useAuth} from "../../providers/authprovider";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import CreateOfferForm from "./CreateOfferForm";
import OffersTable from "./OffersTable";
import OfferTemplates from "./OfferTemplates";
import CreateTemplateForm from "./CreateTemplateForm";
import useAlert from "../../components/CustomAlert";
import FolderGrid from "../../components/FolderGrid";
import SearchBuildingBar from "../../components/SearchBuildingBar";
import Loading from "../../components/LoadingInfo";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLayerGroup} from "@fortawesome/free-solid-svg-icons";



export default function Offers(props){
    const {privilege} = props;
    const navigate = useNavigate();
    const { offers:{get:getOffers, remove, templates: templatesApi}, buildings : {getShort}, user} = useAuth();
    const {alert, showAlert} = useAlert()
    const [buildingFolders, setBuildingFolders] = useState(undefined);
    const [buildingFilter, setBuildingFilter] = useState(undefined);
    const [shortBuildings, setShortBuildings] = useState(undefined);
    const [offerTemplates, setOfferTemplates] = useState(undefined);
    const folders = useMemo(()=>{
        if(!buildingFilter)
            return buildingFolders;

        if(!buildingFolders)
            return []

        return buildingFolders.filter(bf=>bf.building_id === buildingFilter.id)
    }, [buildingFolders, buildingFilter])

    useEffect(()=>{
        if(shortBuildings === undefined){
            getShort(({success, error, content})=>{
                if(!success)
                    return showAlert(error);

                setShortBuildings(content);
            })
            return;
        }

        if(buildingFolders!==undefined)
            return;

        getOffers(({success, error, content})=>{
            if(success)
                return setBuildingFolders(content);

            setBuildingFolders([]);
            showAlert(error);
        })
    })

    useEffect(()=>{
        templatesApi.list(({success, content})=>{
            if(success)
                setOfferTemplates(content);
        })
    }, [])

    const handleSelectFolder = (folder)=>{
        navigate(`./${folder.building_id}`);
    }

    const handleSelectBuilding = (building)=>{
        setBuildingFilter(building)
    }

    const handleCreateNewOffer = (offerType)=>{
        navigate(`/offers/create/${offerType}`);
    }

    const handleCreateFromTemplate = (templateId)=>{
        navigate(`/offers/create/template/${templateId}`);
    }

    const handleTemplateSave = (template)=>{
        // TODO: po wpięciu zapisu szablonu w backendzie zaktualizować listę szablonów
        navigate('/offers/templates');
    }

    const handleStartEdit = (offer, copy)=>{
        let id = offer ? offer.id : '';
        let path = copy === undefined ? 'edit' : 'copy';
        navigate(`/offers/${path}/${id}`);
    }


    const handleOfferSave = (offer, add)=>{
        if(!add) return navigate(-1);


        if(!offer.building.id){
            return setBuildingFolders(oldFolders=>{
                let found = false;

                oldFolders.forEach(folder=>{
                    if(!folder.building_id){
                        folder.files++
                        found = true
                    }

                })

                if(!found)
                    oldFolders.push({building_id: null, name:null, files:1})

                return [...oldFolders]
            })
        }


        let found = false;

        setBuildingFolders(oldFolders=>{
            oldFolders.forEach(folder=>{
                if(folder.building_id === offer.building.id) {
                    folder.files++;
                    found = true;
                }
            })

            if(!found)
                oldFolders.push({building_id: offer.building.id, name:offer.building.name, files:1})

            return [...oldFolders];
        })
        //navigate(-1)
    }

    const handleRemoveOffer = (offer)=>{
        setBuildingFolders(oldFolders=>{
            oldFolders.forEach(folder=>{
                if(folder.building_id === offer.building?.id) {
                    folder.files--;
                }
            })


            return [...oldFolders.filter(f=>f.files > 0)];
        })

    }

    const dataLoaded = shortBuildings && buildingFolders;


    return (
        <div className={"bg-light p-4"}>
            <div className={"container p-2"}>
                {alert()}

                {
                    dataLoaded && <Routes>
                        <Route path={'/'} element={
                            <>
                                <Row>
                                    <Col lg={6}>
                                        <SearchBuildingBar onSelect={handleSelectBuilding}  defaultValue={buildingFilter} buildings={shortBuildings} />
                                    </Col>
                                    <Col>
                                        {
                                            privilege.edit &&
                                            <DropdownButton
                                                className=" mb-3 me-4 float-end"
                                                    title="Nowa oferta"
                                                    id="bg-vertical-dropdown-3"
                                                >
                                                    <Dropdown.Item eventKey="1" onClick={()=>handleCreateNewOffer("offer_aeration")}>Napowietrzanie</Dropdown.Item>
                                                    <Dropdown.Item eventKey="2" onClick={()=>handleCreateNewOffer("offer_smoke_removal")}>Oddymianie</Dropdown.Item>
                                                    <Dropdown.Item eventKey="3" onClick={()=>handleCreateNewOffer("offer_simple")}>Prosta</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Header>Szablony</Dropdown.Header>
                                                    {
                                                        offerTemplates && offerTemplates.length > 0
                                                            ? offerTemplates.map(template =>
                                                                <Dropdown.Item key={template.id} onClick={()=>handleCreateFromTemplate(template.id)}>{template.name}</Dropdown.Item>
                                                            )
                                                            : <Dropdown.Item disabled>Brak szablonów</Dropdown.Item>
                                                    }
                                                </DropdownButton>
                                        }
                                        {
                                            (user?.isAdmin || privilege.edit) &&
                                            <Button variant={"outline-primary"} className="mb-3 me-2 float-end" onClick={()=>navigate('/offers/templates')}><FontAwesomeIcon icon={faLayerGroup} /> Szablony</Button>
                                        }

                                    </Col>
                                </Row>

                                <FolderGrid folders={folders} onSelect={handleSelectFolder} />
                            </>
                        } />
                        <Route path={'/templates'} element={<OfferTemplates privilege={privilege} />} />
                        <Route path={'/templates/create/:offerType'} element={<CreateTemplateForm shortBuildings={shortBuildings} handleSave={handleTemplateSave} />} />
                        <Route path={'/templates/edit/:templateId'} element={<CreateTemplateForm shortBuildings={shortBuildings} handleSave={handleTemplateSave} />} />
                        <Route path={'/create/template/:templateId'} element={<CreateOfferForm shortBuildings={shortBuildings} handleSave={(o)=>handleOfferSave(o, true)} />} />
                        <Route path={'/create/:offerType'} element={<CreateOfferForm shortBuildings={shortBuildings} handleSave={(o)=>handleOfferSave(o, true)} />} />
                        <Route path={'/edit/:offerId'} element={<CreateOfferForm shortBuildings={shortBuildings} handleSave={handleOfferSave} />} />
                        <Route path={'/copy/:offerId'} element={<CreateOfferForm copy={true} shortBuildings={shortBuildings} handleSave={(o)=>handleOfferSave(o, true)} />} />
                        <Route path={'/:buildingId'} element={<OffersTable shortBuildings={shortBuildings} privilege={privilege} handleEdit={handleStartEdit} handleRemove={handleRemoveOffer} offerTemplates={offerTemplates} handleCreateFromTemplate={handleCreateFromTemplate} />} />
                    </Routes>
                }
                <Loading show={!dataLoaded} />


            </div>
        </div>

    )

}






